import React from "react";
import { observer } from "mobx-react-lite";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import { useStore } from "csi/state/hooks";
import { useLocale } from "designSystem/locale";
import PaneHeader from "designSystem/components/pane/PaneHeader";

const FashionInspirationPaneHeader = observer(() => {
	const {
		selectedExplorationData,
	} = useManageFashionInspirationStore();
	const { rightPaneStore, routerStore } = useStore();
	const loc = useLocale();
	const { locationName } = routerStore;
	const { closeSelected, selected } = rightPaneStore;
	const paneTitle = selectedExplorationData?.name || loc.resource(selected.id);
	const fashionInspirationStore = useManageFashionInspirationStore();
	const { showExplorationPinnedImagesPane, setCloseExplorationPinnedImagesPane } = fashionInspirationStore;

	return (
		<PaneHeader
			back={showExplorationPinnedImagesPane}
			onBack={setCloseExplorationPinnedImagesPane}
			onClose={closeSelected}
			subTitle={locationName}
			title={paneTitle}
		/>
	);
});

export default FashionInspirationPaneHeader;
